/** REST klient pro globální layouty (page-builder). Zdrojem pravdy je databáze. */

import type { LayoutDoc } from "@globals/layouts";
import { getAsync, postAsync, putAsync } from "./axios";

export type LayoutRow = {
  key: string;
  name: string;
  layoutJson: LayoutDoc;
  version: number;
  updatedBy: string | null;
  updatedAt: string;
  /** Má plocha tovární kopii? Bez ní nejde nabídnout „Obnovit výchozí". */
  hasSeed: boolean;
};

export const getLayouts = () => getAsync<ApiResp<LayoutRow[]>>("/api/layouts");
export const getLayout = (key: string) => getAsync<ApiResp<LayoutRow>>(`/api/layouts/${key}`);

export const putLayout = (key: string, body: { name: string; version: number; doc: LayoutDoc }) =>
  putAsync<ApiResp<{ version: number }>>(`/api/layouts/${key}`, body);

/** Destruktivní — proto bere `version` a server ji kontroluje. */
export const resetLayout = (key: string, version: number) =>
  postAsync<ApiResp<{ version: number }>>(`/api/layouts/${key}/reset`, { version });

/** „Nastavit současný stav jako tovární." Obsah plochy se nemění. */
export const setLayoutSeed = (key: string, version: number) =>
  postAsync<ApiResp<{ hasSeed: boolean }>>(`/api/layouts/${key}/seed`, { version });

export const createLayout = (body: { key: string; name: string; doc: LayoutDoc }) =>
  postAsync<ApiResp<{ key: string; version: number }>>("/api/layouts", body);
